import React, { Component } from 'react';
import { message, Upload } from 'antd';
import Utils from '@/utils';
import AudioWorkContentFooterRender from './children/AudioWorkContentFooterRender';
import '@/assets/audioAddMusic.less';
import sentGAEvent from '@/ga';
class AudioWorkContentFooterFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.stopUpload = false;
  }

  uploadProps = {
    accept: this.props.accept,
    maxCount: 2,
    multiple: true,
    showUploadList: false,
    beforeUpload: async (file, fileList) => {
      this.props.handlePauseAllAudio();
      if (this.stopUpload) {
        if (file.uid === fileList[fileList.length - 1].uid) {
          this.stopUpload = false;
        }
        return Upload.LIST_IGNORE;
      }
      this.stopUpload = true;
      if (
        fileList.length > 2 ||
        this.props.audioAddMusicList.length + fileList.length > 2
      ) {
        message.warn(`最多添加2个音频`);
      }
      sentGAEvent({
        category: 'add_music_add_files',
        action: 'add_music_add_files',
        label:
          (fileList.length + this.props.audioAddMusicList.length > 2
            ? 2 - this.props.audioAddMusicList.length
            : fileList.length) + '_add tracks',
      });
      const audioAddMusicList = [...this.props.audioAddMusicList];
      for (let index = 0; index < fileList.length; index++) {
        let item = fileList[index];
        // if (item.size >= 20 * 1024 * 1024) {
        //   // message.warn("Max item size for videos is 20 MB. Get HitPaw Toolkit for big file.");
        //   this.props.handleWarningObj({
        //     warningInfo: true,
        //     warningInfoText: "Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.",
        //     warningInfoObj: {
        //       type: "size",
        //       size: (item.size / 1024 / 1024).toFixed(2),
        //     },
        //   });
        // } else
        if (!Utils.validate(item, '.wav,.mp3,.m4a,.aac,.ogg,.mp4,.mov,.webm')) {
          // message.warn(`The file ${item.name} format is not supported!`);
          this.props.handleWarningObj({
            warningInfo: true,
            warningInfoText: 'This format is not supported currently.',
            warningInfoObj: {
              type: 'format',
              format: /\.[^.]+$/.exec(item.name)[0].toLocaleLowerCase(),
            },
          });
        } else if (audioAddMusicList.length < 2) {
          if (item.size >= 20 * 1024 * 1024) {
            if (Utils.isNeedToShowPurchaseModal()) {
              this.props.handlePurchaseModalObjChange({
                visible: true,
                type: 'uploadSizeBiggerThanLimit',
              });
              let action = Utils.gaUpgradePromptShow(this.props.work);

              if (action) {
                sentGAEvent({
                  category: 'UpgradePrompShow',
                  action: action,
                  label: 'Null',
                });
              }
              return Upload.LIST_IGNORE;
            }
          }
          let fileToBlobResponse = await Utils.fileToBlob(file);
          if (fileToBlobResponse) {
            const newFile = {
              name: item.name,
              guid: new Date().getTime() + index,
              size: item.size,
              status: 'ready',
              uploadStatus: false,
              fileObj: item,
              videofileurl: fileToBlobResponse.blobUrl,
              duration: fileToBlobResponse.duration,
              type: item.type,
              start: '00:00.00',
              end: fileToBlobResponse.duration,
              volume: 1,
              startPercent: 0,
              dragX: 0,
              dragXTime: 0,
              isLarge: false,
              wavesurferContRef: React.createRef(),
            };
            if (
              Utils.getSeconds(
                audioAddMusicList[audioAddMusicList.length - 1].duration
              ) < Utils.getSeconds(newFile.duration)
            ) {
              audioAddMusicList[audioAddMusicList.length - 1].isLarge = false;
              newFile.isLarge = true;
            }
            audioAddMusicList.push(newFile);
          }
        }
      }
      this.props.onAudioAddMusicListChange(audioAddMusicList);
      return Upload.LIST_IGNORE;
    },
  };

  handleStopUpload = () => {
    this.stopUpload = false;
  };

  render() {
    return (
      <AudioWorkContentFooterRender
        uploadProps={this.uploadProps}
        handleStopUpload={this.handleStopUpload}
      />
    );
  }
}

export default AudioWorkContentFooterFunction;
